<div class="aca-admin aca-fav">
  <aca-page-header icon="star" [title]="'DMS.FAVORITES_PAGE.560AE4' | translate" [subtitle]="'DMS.UI.81F853' | translate" />

  <!-- ── tabs + toolbar ─────────────────────────────────────────────────── -->
  <div class="aca-fav__bar">
    <div class="aca-fav__tabs" role="tablist">
      <button
        type="button"
        role="tab"
        class="aca-fav__tab"
        *ngFor="let tab of tabs"
        [class.aca-fav__tab--on]="kind === tab.kind"
        [attr.aria-selected]="kind === tab.kind"
        (click)="selectTab(tab.kind)"
      >
        {{ tab.label | translate }}
        <span class="aca-fav__tabcount" *ngIf="countFor(tab.kind) !== null">({{ countFor(tab.kind) }})</span>
      </button>
    </div>

    <div class="aca-fav__baractions">
      <button
        type="button"
        class="aca-fav__outline"
        [class.aca-fav__outline--on]="pinnedOnly()"
        (click)="togglePinnedOnly()"
        [matTooltip]="pinnedOnly() ? ('DMS.UI.9F3452' | translate) : ('DMS.UI.44B69E' | translate)"
      >
        <mat-icon>push_pin</mat-icon>{{ 'DMS.FAVORITES_PAGE.66C565' | translate }}
      </button>

      <label class="aca-fav__filter">
        <span class="aca-fav__filterlabel">{{ 'DMS.FAVORITES_PAGE.58DB33' | translate }}</span>
        <select class="aca-fav__select" [ngModel]="sort" (ngModelChange)="changeSort($event)">
          <option *ngFor="let option of sorts" [value]="option.value">{{ option.label | translate }}</option>
        </select>
      </label>

      <div class="aca-fav__viewtoggle">
        <button
          type="button"
          class="aca-fav__iconbtn"
          [class.aca-fav__iconbtn--on]="view() === 'list'"
          (click)="setView('list')"
          [matTooltip]="'DMS.FAVORITES_PAGE.3519B3' | translate"
          [attr.aria-label]="'DMS.FAVORITES_PAGE.3519B3' | translate"
        >
          <mat-icon>view_list</mat-icon>
        </button>
        <button
          type="button"
          class="aca-fav__iconbtn"
          [class.aca-fav__iconbtn--on]="view() === 'grid'"
          (click)="setView('grid')"
          [matTooltip]="'DMS.FAVORITES_PAGE.81D7AA' | translate"
          [attr.aria-label]="'DMS.FAVORITES_PAGE.81D7AA' | translate"
        >
          <mat-icon>grid_view</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <mat-progress-bar mode="indeterminate" *ngIf="loading()" />

  <aca-page-state
    *ngIf="failed()"
    state="error"
    [title]="'DMS.FAVORITES_PAGE.CA5CF4' | translate"
    [message]="failed()"
    [actionLabel]="'DMS.UI.324E7E' | translate"
    (action)="reload()"
  />

  <aca-page-state
    *ngIf="!failed() && !loading() && !rows().length"
    state="empty"
    icon="star_border"
    [title]="'DMS.FAVORITES_PAGE.4930A9' | translate"
    [message]="'DMS.UI.D93FB4' | translate"
    [actionLabel]="'DMS.UI.0DB88F' | translate"
    (action)="addFavorites()"
  />

  <ng-container *ngIf="!failed() && rows().length">
    <!-- ── pinned strip ─────────────────────────────────────────────────── -->
    <section class="aca-fav__section" *ngIf="pinnedRows().length">
      <h2 class="aca-fav__sectiontitle"><mat-icon>push_pin</mat-icon>{{ 'DMS.FAVORITES_PAGE.66C565' | translate }}</h2>

      <div class="aca-fav__cards">
        <article class="aca-fav__card" *ngFor="let row of pinnedRows(); trackBy: trackById">
          <header class="aca-fav__cardhead">
            <span class="aca-fav__badge" [ngClass]="badgeClass(row)">
              <mat-icon *ngIf="row.kind !== 'file'">{{ row.kind === 'folder' ? 'folder' : 'library_books' }}</mat-icon>
              <ng-container *ngIf="row.kind === 'file'">{{ badge(row) }}</ng-container>
            </span>

            <button type="button" class="aca-fav__cardname" (click)="open(row)" [matTooltip]="row.name">{{ row.name }}</button>

            <button
              type="button"
              class="aca-fav__star aca-fav__star--on"
              (click)="togglePin(row)"
              [matTooltip]="'DMS.FAVORITES_PAGE.5D44FF' | translate"
              [attr.aria-label]="'DMS.FAVORITES_PAGE.5D44FF' | translate"
            >
              <mat-icon>push_pin</mat-icon>
            </button>

            <button
              mat-icon-button
              [matMenuTriggerFor]="cardMenu"
              [matTooltip]="'DMS.FAVORITES_PAGE.6D5E7B' | translate"
              [attr.aria-label]="'DMS.FAVORITES_PAGE.6D5E7B' | translate"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #cardMenu="matMenu">
              <button mat-menu-item (click)="open(row)">
                <mat-icon>open_in_new</mat-icon><span>{{ 'DMS.FAVORITES_PAGE.22AADB' | translate }}</span>
              </button>
              <button mat-menu-item (click)="download(row)" [disabled]="row.kind !== 'file'">
                <mat-icon>download</mat-icon><span>{{ 'DMS.FAVORITES_PAGE.13EA03' | translate }}</span>
              </button>
              <button mat-menu-item (click)="removeFavorite(row)">
                <mat-icon>star_border</mat-icon><span>{{ 'DMS.FAVORITES_PAGE.8E6758' | translate }}</span>
              </button>
            </mat-menu>
          </header>

          <p class="aca-fav__cardpath">{{ row.location || '—' }}</p>

          <footer class="aca-fav__cardfoot">
            <span>{{ 'DMS.UI.DC1FAC' | translate }} {{ row.modifiedAt | acaDate: 'd MMM y HH:mm' }}</span>
            <span *ngIf="row.modifiedByName">{{ 'DMS.UI.78ABAC' | translate }} {{ row.modifiedByName }}</span>
          </footer>
        </article>
      </div>
    </section>

    <!-- ── list ─────────────────────────────────────────────────────────── -->
    <section class="aca-fav__section">
      <h2 class="aca-fav__sectiontitle">
        {{ pinnedOnly() ? ('DMS.UI.3D38EC' | translate) : ('DMS.UI.4D0D1C' | translate) }}
        <span class="aca-fav__sectionnote" *ngIf="hasMore()"
          >{{ 'DMS.UI.1D31FB' | translate }} {{ listRows().length }} {{ 'DMS.UI.D74653' | translate }}</span
        >
      </h2>

      <aca-page-state
        *ngIf="!listRows().length"
        state="empty"
        icon="push_pin"
        [title]="'DMS.FAVORITES_PAGE.1C2235' | translate"
        [message]="'DMS.UI.32CD59' | translate"
      />

      <!-- list view -->
      <div class="aca-fav__tablewrap" *ngIf="listRows().length && view() === 'list'">
        <table class="aca-fav__table">
          <thead>
            <tr>
              <th class="aca-fav__th aca-fav__th--name">{{ 'DMS.FAVORITES_PAGE.85B482' | translate }}</th>
              <th class="aca-fav__th">{{ 'DMS.FAVORITES_PAGE.AEABC8' | translate }}</th>
              <th class="aca-fav__th">{{ 'DMS.FAVORITES_PAGE.00D97A' | translate }}</th>
              <th class="aca-fav__th">{{ 'DMS.FAVORITES_PAGE.E38F3B' | translate }}</th>
              <th class="aca-fav__th">{{ 'DMS.FAVORITES_PAGE.8B2C99' | translate }}</th>
              <th class="aca-fav__th aca-fav__th--actions"></th>
            </tr>
          </thead>
          <tbody>
            <tr class="aca-fav__row" *ngFor="let row of listRows(); trackBy: trackById" (dblclick)="open(row)">
              <td class="aca-fav__td aca-fav__td--name">
                <span class="aca-fav__badge" [ngClass]="badgeClass(row)">
                  <mat-icon *ngIf="row.kind !== 'file'">{{ row.kind === 'folder' ? 'folder' : 'library_books' }}</mat-icon>
                  <ng-container *ngIf="row.kind === 'file'">{{ badge(row) }}</ng-container>
                </span>
                <button type="button" class="aca-fav__name" (click)="open(row)">{{ row.name }}</button>
                <mat-icon class="aca-fav__pinmark" *ngIf="row.pinned" [matTooltip]="'DMS.FAVORITES_PAGE.4146C1' | translate">push_pin</mat-icon>
              </td>
              <td class="aca-fav__td">
                <span class="aca-fav__chip">{{ label(row.documentType) || kindLabel(row) | translate }}</span>
              </td>
              <td class="aca-fav__td">{{ row.location || '—' }}</td>
              <td class="aca-fav__td">{{ row.modifiedAt | acaDate: 'd MMM y HH:mm' }}</td>
              <td class="aca-fav__td">
                <span class="aca-fav__owner" *ngIf="row.modifiedByName">
                  <span class="aca-fav__avatar">{{ initials(row.modifiedByName) }}</span>
                  {{ row.modifiedByName }}
                </span>
                <span *ngIf="!row.modifiedByName">—</span>
              </td>
              <td class="aca-fav__td aca-fav__td--actions">
                <span class="aca-fav__rowactions">
                  <button
                    mat-icon-button
                    (click)="open(row)"
                    [matTooltip]="'DMS.FAVORITES_PAGE.22AADB' | translate"
                    [attr.aria-label]="'DMS.FAVORITES_PAGE.22AADB' | translate"
                  >
                    <mat-icon>open_in_new</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    (click)="download(row)"
                    [disabled]="row.kind !== 'file'"
                    [matTooltip]="'DMS.FAVORITES_PAGE.13EA03' | translate"
                    [attr.aria-label]="'DMS.FAVORITES_PAGE.13EA03' | translate"
                  >
                    <mat-icon>download</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    [matMenuTriggerFor]="rowMenu"
                    [matTooltip]="'DMS.FAVORITES_PAGE.6D5E7B' | translate"
                    [attr.aria-label]="'DMS.FAVORITES_PAGE.6D5E7B' | translate"
                  >
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #rowMenu="matMenu">
                    <button mat-menu-item (click)="open(row)">
                      <mat-icon>open_in_new</mat-icon><span>{{ 'DMS.FAVORITES_PAGE.22AADB' | translate }}</span>
                    </button>
                    <button mat-menu-item (click)="togglePin(row)">
                      <mat-icon>push_pin</mat-icon><span>{{ row.pinned ? ('DMS.UI.B7E553' | translate) : ('DMS.UI.BF8847' | translate) }}</span>
                    </button>
                    <button mat-menu-item class="aca-fav__danger" (click)="removeFavorite(row)">
                      <mat-icon>star_border</mat-icon><span>{{ 'DMS.FAVORITES_PAGE.8E6758' | translate }}</span>
                    </button>
                  </mat-menu>
                  <button
                    type="button"
                    class="aca-fav__star aca-fav__star--filled"
                    (click)="removeFavorite(row)"
                    [matTooltip]="'DMS.FAVORITES_PAGE.8E6758' | translate"
                    [attr.aria-label]="'DMS.FAVORITES_PAGE.8E6758' | translate"
                  >
                    <mat-icon>star</mat-icon>
                  </button>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- grid view -->
      <div class="aca-fav__cards aca-fav__cards--grid" *ngIf="listRows().length && view() === 'grid'">
        <article class="aca-fav__card" *ngFor="let row of listRows(); trackBy: trackById">
          <header class="aca-fav__cardhead">
            <span class="aca-fav__badge" [ngClass]="badgeClass(row)">
              <mat-icon *ngIf="row.kind !== 'file'">{{ row.kind === 'folder' ? 'folder' : 'library_books' }}</mat-icon>
              <ng-container *ngIf="row.kind === 'file'">{{ badge(row) }}</ng-container>
            </span>
            <button type="button" class="aca-fav__cardname" (click)="open(row)" [matTooltip]="row.name">{{ row.name }}</button>
            <button
              type="button"
              class="aca-fav__star"
              [class.aca-fav__star--on]="row.pinned"
              (click)="togglePin(row)"
              [matTooltip]="row.pinned ? ('DMS.UI.B7E553' | translate) : ('DMS.UI.BF8847' | translate)"
              [attr.aria-label]="row.pinned ? ('DMS.UI.B7E553' | translate) : ('DMS.UI.BF8847' | translate)"
            >
              <mat-icon>push_pin</mat-icon>
            </button>
          </header>

          <p class="aca-fav__cardpath">{{ row.location || '—' }}</p>

          <footer class="aca-fav__cardfoot">
            <span>{{ 'DMS.UI.DC1FAC' | translate }} {{ row.modifiedAt | acaDate: 'd MMM y HH:mm' }}</span>
            <span *ngIf="row.modifiedByName">{{ 'DMS.UI.78ABAC' | translate }} {{ row.modifiedByName }}</span>
          </footer>
        </article>
      </div>
    </section>
  </ng-container>

  <button type="button" class="aca-fav__fab" (click)="addFavorites()"><mat-icon>add</mat-icon>{{ 'DMS.FAVORITES_PAGE.E3DBC8' | translate }}</button>
</div>
